import {Component, Input} from '@angular/core'

@Component({
  selector: 'spb-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent {
  @Input() text = 'Vänta'
}
